import api from './api';

// Admin > Billing > Invoices — OHIP usage invoicing.
//
// One endpoint with actions in the body rather than a path per operation: every new path is a code-admin
// API Gateway change, and all of this belongs to one screen and one reader.
//
// `preview` and `generate` take the SAME arguments and are computed by the same server code, so what the
// wizard shows is what generation writes. A preview that could disagree with the result would be worse
// than no preview.
const ohipInvoicesService = {
    list: (params) => api.get('/admin/ohip-invoices', { params }),
    months: () => api.get('/admin/ohip-invoices', { params: { view: 'months' } }),
    environments: () => api.get('/admin/ohip-invoices', { params: { view: 'environments' } }),
    rates: () => api.get('/admin/ohip-invoices', { params: { view: 'rates' } }),
    customers: () => api.get('/admin/ohip-invoices', { params: { view: 'customers' } }),
    config: () => api.get('/admin/ohip-invoices', { params: { view: 'config' } }),

    get: (id) => api.get(`/admin/ohip-invoices/${id}`),

    // Computed, never saved.
    preview: ({ month, environmentIds }) =>
        api.post('/admin/ohip-invoices', { action: 'preview', month, environmentIds }),
    // Idempotent: (environment, month) is unique, so a second call rewrites the same draft rather than
    // raising a second invoice. Anything past DRAFT is left alone and reported as skipped.
    generate: ({ month, environmentIds, send }) =>
        api.post('/admin/ohip-invoices', { action: 'generate', month, environmentIds, send }),
    send: (id) => api.post(`/admin/ohip-invoices/${id}`, { action: 'send' }),

    update: (id, data) => api.put(`/admin/ohip-invoices/${id}`, data),
    remove: (id) => api.delete(`/admin/ohip-invoices/${id}`),

    saveRate: (data) => api.post('/admin/ohip-invoices', { action: 'rate', ...data }),
    deleteRate: (rateId) => api.delete('/admin/ohip-invoices', { params: { rateId } }),
    saveCustomer: (data) => api.post('/admin/ohip-invoices', { action: 'customer', ...data }),
};

export default ohipInvoicesService;
